import React from "react";
import { legacy_createStore as createStore } from "redux";
import { Provider } from "react-redux";
import QuestionSteps from "./screens/QuestionSteps";
import rootReducer from "./reducers";
// for redux
// 1.Store--> Globalized State
// 2.Action
// 3.Reducer
// 4.Dispatch
const myStore = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
console.warn("store data", myStore);
function App() {
  return (
    <Provider store={myStore}>
      <QuestionSteps />
    </Provider>
  );
}

export default App;
